import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { StoreProvider } from "@/context/StoreContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WishlistDrawer from "@/components/WishlistDrawer";
import SearchModal from "@/components/SearchModal";
import QuickViewModal from "@/components/QuickViewModal";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import { ScrollToTop } from "@/components/ScrollToTop";

function Storefront() {
  return (
    <StoreProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/parfum/:id" element={<ProductDetail />} />
        <Route path="/payment/success" element={<PaymentResult mode="success" />} />
        <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
      </Routes>
      <Footer />
      <CartDrawer />
      <WishlistDrawer />
      <SearchModal />
      <QuickViewModal />
      <WhatsAppButton />
    </StoreProvider>
  );
}

function Shell() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <Admin />;
  return <Storefront />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#FBF8F3", color: "#2A2421", border: "1px solid #E5DDD0", borderRadius: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
